import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().min(1).max(100);
const savedSchema = z.string().min(1).max(100);
const jsonSchema = z.string();
/**
 * 機関名(値オブジェクト)のメタデータ。
 *
 * 機関の名称。 */
export const institutionNameMeta = new ValueObjectMetaString(
  "InstitutionName",
  "\u6A5F\u95A2\u540D",
  messageId("lbl.\u6A5F\u95A2\u540D"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
